<div class="benefit">
  <div class="benefit__icon">
    <app-icon [name]="icon()" />
  </div>
  <div class="benefit__text">
    <div class="benefit__text-title">{{ title() }}</div>
    <div class="benefit__text-description">
      {{ description() }}
    </div>
  </div>
</div>
